import React, { Component } from 'react';

import {
  withStyles,
  Typography,
  CssBaseline,
  Card,
  Grid,
} from '@material-ui/core';

import SearchBar from 'material-ui-search-bar';
import { withRouter, useHistory, Link } from 'react-router-dom';

const styles = () => {
  return {
    page: {
      textAlign: 'center',
    },
    title: {
      marginBottom: '2em',
    },
    searchContainer: {
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '7em',
    },
    categoryContainer: {
      maxWidth: 1000,
      marginLeft: 'auto',
      marginRight: 'auto',
      marginTop: '7em',
    },
    categoryItem: {
      minWidth: 320,
      maxWidth: '95%',
      marginLeft: 'auto',
      marginRight: 'auto',
      paddingLeft: '1em',
      paddingRight: '1em',
      paddingTop: '4em',
      paddingBottom: '4em',
    },
    suggestion: {
      width: '100%',
      paddingLeft: '2em',
      textAlign: 'left',
      marginLeft: 'auto',
      marginRight: 'auto',
      maxWidth: 1000,
      minHeight: 30,
      backgroundColor: 'white',
      paddingTop: 3,
      paddingBottom: 3,
      '&:hover': {
        backgroundColor: '#D3D3D3 !important',
      },
    },
    bottomSuggestion: {
      width: '100%',
      paddingLeft: '2em',
      textAlign: 'left',
      maxWidth: 1000,
      marginLeft: 'auto',
      marginRight: 'auto',
      minHeight: 30,
      backgroundColor: 'white',
      paddingTop: 3,
      paddingBottom: 3,
      borderBottomLeftRadius: 15,
      borderBottomRightRadius: 15,
      '&:hover': {
        backgroundColor: '#D3D3D3 !important',
      },
    },
  };
};

const renderSuggestion = (suggestion, classes) => (
  <div className={classes.suggestion}>
    <Link
      to={'/term/' + suggestion}
      style={{ textDecoration: 'none', color: 'black' }}
    >
      <Typography variant="h6">{suggestion}</Typography>
    </Link>
  </div>
);

const renderBottomSuggestion = (suggestion, classes) => (
  <div className={classes.bottomSuggestion}>
    <Link
      to={'/term/' + suggestion}
      style={{ textDecoration: 'none', color: 'black' }}
    >
      <Typography variant="h6">{suggestion}</Typography>
    </Link>
  </div>
);

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: [],
      searchVal: '',
      isSignedIn: false,
      terms: Object.keys(props.definitions),
    };
  }

  getSuggestions = ({ value }) => {
    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;

    return inputLength === 0
      ? []
      : this.state.terms.filter(
          (term) => term.toLowerCase().slice(0, inputLength) === inputValue
        );
  };

  onSuggestionsFetchRequested = (value) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  routeChange = (path) => {
    let history = useHistory();
    history.push(path);
  };

  render() {
    const { classes, categories } = this.props;

    const inputProps = {
      placeholder: 'Search',
      value: this.state.searchVal,
      onChange: (evt) => {
        this.setState({ searchVal: evt.target.val });
      },
    };

    return (
      <div className={classes.page}>
        <CssBaseline />

        <div className={classes.searchContainer}>
          <div className={classes.title}>
            <Typography variant="h1">ASL STEM</Typography>
          </div>

          {/* Search Bar */}
          <SearchBar
            {...inputProps}
            onChange={(value) => {
              this.setState({ searchVal: value });
              this.onSuggestionsFetchRequested({ value });
            }}
            onRequestSearch={() => {
              if (this.state.searchVal !== '')
                this.props.history.push('/search/' + this.state.searchVal);
            }}
            onCancelSearch={() => {
              this.setState({ searchVal: '' });
            }}
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              marginBottom: 3,
              width: '95%',
              maxWidth: 1000,
            }}
          />

          {/* Suggestions */}
          {this.state.suggestions.length === 0 ? (
            <div />
          ) : (
            this.state.suggestions
              .slice(0, 7)
              .map((sug, index) =>
                index === this.state.suggestions.length - 1 || index > 5
                  ? renderBottomSuggestion(sug, classes)
                  : renderSuggestion(sug, classes)
              )
          )}
        </div>

        {/* Categories */}
        <div className={classes.categoryContainer}>
          <div className={classes.title}>
            <Typography variant="h4">Categories</Typography>
          </div>
          <Grid container spacing={6}>
            {categories.map((category) => (
              <Grid item xs={12} sm={6} md={4}>
                <Link
                  style={{ textDecoration: 'none', color: 'black' }}
                  to={'/term/' + category}
                >
                  <Card className={classes.categoryItem}>
                    <Typography variant="h4">{category}</Typography>
                  </Card>
                </Link>
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(HomePage));
